import { FormField, SearchField } from '@/components/custom/erp';
import { thuChiSearchColumns } from '../../cols-definition';
import { FormActions, FormState } from '../../hooks';
import { Label } from '@/components/ui/label';
import { ThuChi } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
  formState: {
    state: FormState;
    actions: FormActions;
  };
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ formMode, formState: { state, actions } }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-36 min-w-36' required>
            Mã thu chi
          </Label>
          <div className='w-[240px]'>
            <FormField type='text' name='ma_thu_chi' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36' required>
            Tên thu chi
          </Label>
          <div className='w-full'>
            <FormField type='text' name='ten_thu_chi' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Mã cha</Label>
          <SearchField<ThuChi>
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.THU_CHI}/`}
            searchColumns={thuChiSearchColumns}
            dialogTitle='Danh mục thu chi'
            columnDisplay='ma_thu_chi'
            displayRelatedField='ten_thu_chi'
            onRowSelection={actions.setParent}
            value={state.parent?.ma_thu_chi || ''}
            relatedFieldValue={state.parent?.ten_thu_chi}
            className='w-100'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Ghi chú</Label>
          <div className='w-full'>
            <FormField type='text' name='ghi_chu' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Số thứ tự</Label>
          <div className='w-[120px]'>
            <FormField type='number' name='stt' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Trạng thái</Label>
          <div className='w-[250px]'>
            <FormField
              type='select'
              name='trang_thai'
              disabled={formMode === 'view'}
              options={[
                { label: '1. Còn sử dụng', value: 1 },
                { label: '0. Không sử dụng', value: 0 }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
